import { gql } from '@apollo/client'

export const BILLING_DETAILS_FRAGMENT = gql`
  fragment BillingDetails on BillingDetails {
    name
    email
    phone
    address {
      line1
      line2
      city
      state
      postalCode
      country
    }
  }
`
